import Vue from 'vue'
import Router from 'vue-router'
import oidcJS from '../public/oidcRoot'

Vue.use(Router)

const router = new Router({
  // base: '/portal/',
  mode: 'history',
  routes: [
    {
      path: "/",
      redirect: "/tyPortal"
    },
    // {
    //   path: '/mySaaS',        //我的维易
    //   name: 'mySaaS',
    //   redirect: '/vsHome',//  我的维易主页
    //   component: resolve => require(['@/components/basics/mySaaS'],resolve),
    //   children:[
    //     {
    //       path: '/vsHome',//  我的维易主页
    //       name: 'vsHome',
    //       component: resolve => require(['@/components/vesaas/vsHome'],resolve),
    //       meta:{isLogin:true,
    //         permissions:'Allow_PlatformCenterMenuItem',
    //         // titOption:"ProductAndServceMenuItem",
    //         defaultActiveMenu:"",
    //         perantMenuItemName:""
    //       }   //是否需要强制登录
    //     }, {
    //       path: '/vsPurchase',//  购买服务/购买记录
    //       name: 'vsPurchase',
    //       component: resolve => require(['@/components/vesaas/vsPurchase'],resolve),
    //       meta:{isLogin:true,
    //         permissions:'Allow_PlatformCenterMenuItem',
    //         // titOption:"ProductAndServceMenuItem",
    //         defaultActiveMenu:"",
    //         perantMenuItemName:""
    //       }   //是否需要强制登录
    //     },{
    //       path: '/vsBind/PlatformStoreManagementMenuItem',//  店铺中心
    //       name: 'vsBind',
    //       component: resolve => require(['@/components/vesaas/vsBindShop'],resolve),
    //       meta:{isLogin:true,
    //         permissions:'',
    //         // titOption:"ProductAndServceMenuItem",
    //         defaultActiveMenu:"",
    //         perantMenuItemName:""
    //       }   //是否需要强制登录
    //     },{
    //       path: '/vsUs',//  用户中心
    //       name: 'vsUs',
    //       component: resolve => require(['@/components/vesaas/vsUs'],resolve),
    //       meta:{isLogin:true,
    //         permissions:'',
    //         // titOption:"ProductAndServceMenuItem",
    //         defaultActiveMenu:"",
    //         perantMenuItemName:""
    //       }   //是否需要强制登录
    //     },{
    //       path: '/vsMessage',//  消息中心
    //       name: 'vsMessage',
    //       component: resolve => require(['@/components/vesaas/vsMessage'],resolve),
    //       meta:{isLogin:true,
    //         permissions:'',
    //         // titOption:"ProductAndServceMenuItem",
    //         defaultActiveMenu:"",
    //         perantMenuItemName:""
    //       }   //是否需要强制登录
    //     },
    //     ]
    // },
    {
      path: '/main',
      name: 'main',             //首页
      // redirect:'/index',
      component: resolve => require(['@/components/basics/main'],resolve),

      children:[
        {
          path: '/changePassword',        //修改密码
          name: 'changePassword',
          component: resolve => require(['@/components/basics/changePassword'],resolve),
        },
        {
          path: '/register',
          name: 'register',             //主账户注册
          component: resolve => require(['@/components/basics/register'],resolve),
        },
        {
          path: '/register-pc',
          name: 'register-pc',
          redirect:'/register',//主账户注册
          component: resolve => require(['@/components/basics/register'],resolve),
        },
        {
          path: '/companyRegister',
          name: 'companyRegister',             //主账户填写信息
          component: resolve => require(['@/components/basics/companyRegister'],resolve),
        },
        {
          path: '/forgetPsd',
          name:'forgetPsd',
          component: resolve => require(['@/components/basics/forgetPsd'],resolve),
        },
        {
          path: '/againEmail',
          name: 'againEmail',             //再次验证邮箱
          component: resolve => require(['@/components/basics/againEmail'],resolve),
        },
        {
          path: '/activationSuccessful',
          name: 'activationSuccessful',             //激活成功
          component: resolve => require(['@/components/basics/activationSuccessful'],resolve),
        },
        {
          path: '/activationEmail',
          name: 'activationEmail',             //激活邮件
          component: resolve => require(['@/components/basics/activationEmail'],resolve),
        },
      ]
    },
    {
      path: '/callback',
      name: 'callback',             //回调地址
      component: resolve => require(['@/components/basics/callback'],resolve),
    },
    {
      path: '/vsIndex',
      name: 'vsIndex',       //一级左侧vesaas  navigation
      component: resolve => require(['@/components/basics/menuItems'],resolve),// '@/components/basics/navigation'
      // redirect:'/vsIndex',
      meta:{
        isLogin:true,
        permissions:'Allow_PlatformCenterMenuItem',
        defaultActiveMenu:"PlatformCenter",
        perantMenuItemName:"PlatformCenterMenuItem"
      },   //是否需要登录
      children:[//二级头部菜单导航
        // {
        //   path: '/home',//产品与服务
        //   name: 'vsPs',
        //   component: resolve => require(['@/components/vesaas/vsPs'],resolve),
        //   meta:{isLogin:true,
        //     permissions:'',
        //     titOption:"Allow_PlatformCenterMenuItem",
        //     defaultActiveMenu:"",
        //     perantMenuItemName:""
        //   }   //是否需要强制登录
        // },
        // {
        //   path: '/vsIndex',//首页
        //   name: 'vsIndex',
        //   component: resolve => require(['@/components/workbench/workbench'],resolve),
        //   meta:{isLogin:true,
        //     permissions:'Allow_PlatformCenterMenuItem',
        //     titOption:"1",
        //     defaultActiveMenu:"PlatformCenter",
        //     perantMenuItemName:"PlatformCenterMenuItem"
        //   }   //是否需要强制登录
        // },
        {
          path: '/ProductLibraryHomeMenuItem',//首页
          name: 'ProductLibraryHomeMenuItem',
          component: resolve => require(['@/components/workbench/workbench'],resolve),
          meta:{isLogin:true,
            permissions:'Allow_PlatformCenterMenuItem',
            titOption:"1",
            defaultActiveMenu:"PlatformCenter",
            perantMenuItemName:"PlatformCenterMenuItem"
          }   //是否需要强制登录
        },
        {
          path: '/platformgreenchannel',
          name: 'platformgreenchannel',             //平台绿色通道
          component: resolve => require(['@/components/basics/platformGreenChannel'],resolve),
          meta:{
            permissions:'',
            titOption:"27",
            defaultActiveMenu:"PlatformCenter",
            perantMenuItemName:"PlatformCenterMenuItem"
          }
        },
        {
          path: '/vsUs/:id',//用户中心
          name: 'vsUs',
          component: resolve => require(['@/components/vesaas/vsUs'],resolve),
          meta:{isLogin:true,
            permissions:'',
            titOption:"1",
            defaultActiveMenu:"PlatformCenter",
            perantMenuItemName:"PlatformCenterMenuItem"
          }
        },
        {
          path: '/vsCost/:id',//费用中心
          name: 'vsCost',
          component: resolve => require(['@/components/vesaas/vsCost'],resolve),
          meta:{isLogin:true}
        },
        // {
        //   path: '/vsBind/:id',//绑定店铺
        //   name: 'vsBind',
        //   component: resolve => require(['@/components/vesaas/vsBind'],resolve),
        //   meta:{
        //     isLogin:true,
        //     permissions:'Allow_PlatformStoreManagementMenuItem',
        //     titOption:"30",
        //     defaultActiveMenu:"PlatformCenter",
        //     perantMenuItemName:"PlatformCenterMenuItem"
        //   }
        // },
        {
          path: '/vsNews',
          name: 'vsNews',       //所有的消息列表
          // redirect:'/vsNews',
          component: resolve => require(['@/components/vesaas/vsNews'],resolve),
          meta:{isLogin:true}
        },
        {
          path: '/vat',
          name: 'vat',       //vat
          component: resolve => require(['@/components/vat/vat'],resolve),
          meta:{
            isLogin:true,
            permissions:'Allow_VatServiceMenuItem',
            defaultActiveMenu:"VatServiceMenuItem",
          }
        },
        {
          path: '/tyPortal',
          name: 'ty',       //ty
          component: resolve => require(['@/components/trackingYee/ty'],resolve),
          meta:{
            isLogin:true,
            permissions:'Allow_TrackingYeeServiceMenuItem',
            defaultActiveMenu:"TrackingYeeServiceMenuItem",
            perantMenuItemName:"TrackingYeeServiceMenuItem"
          }
        },
        {
          path: '/productService',
          name: 'productService',       //产品库——产品+商品
          component: resolve => require(['@/components/productLibrary/productService'],resolve),
          meta:{
            isLogin:true,
            permissions:'Allow_ProductLibraryProductMenuItem',
            defaultActiveMenu:"ProductLibraryService",
            perantMenuItemName:"ProductLibraryServiceMenuItem"
          }
        },
        {
          path: '/fulfillment',
          name: 'fulfillment',       //ERP销售工具（审单发货）
          component: resolve => require(['@/components/fulfillment/fulfillment'],resolve),
          meta:{
            isLogin:true,
            permissions:'Allow_FulfillmentServiceMenuItem',
            defaultActiveMenu:"FulfillmentService",
            perantMenuItemName:"FulfillmentServiceMenuItem"
          }
        },
        {
          path: '/purchase',
          name: 'purchase',       //采购管理
          component: resolve => require(['@/components/purchase/purchase'], resolve),
          meta: {
            isLogin: true,
            titOption:"66",
            permissions: 'Allow_FulfillmentServiceMenuItem',
            defaultActiveMenu: "PurchasePlanMenuItem",
            perantMenuItemName: "PurchasePlanMenuItem"
          }
        },
        {
          path: '/logProviderAuth',
          name: 'logProviderAuth',             //物流商授权
          component: resolve => require(['@/components/fulfillment/logProviderAuth'],resolve),
          meta:{
            isLogin:true,
            permissions:'Allow_FulfillmentServiceMenuItem',
            titOption:"56",
            defaultActiveMenu:"FulfillmentService",
            perantMenuItemName:"FulfillmentServiceMenuItem"
          }
        },
        {
          path: '/notFound',
          name: 'notFound',       //404
          component: resolve => require(['@/components/basics/not-found'],resolve),
        },
        {
          path: '/error',
          name: 'error',             //再次验证邮箱
          component: resolve => require(['@/components/basics/error'],resolve),
        },
        

      ]
    },
    {
      path: '/authorizeLogin',
      name: 'authorizeLogin',             //授权登录
      component: resolve => require(['@/components/basics/authorizeLogin'],resolve),
    },
    {
      path: "*",
      redirect: "/notFound"
    },
  ]
})
router.beforeEach((to, from, next) => {
  to.matched.map(item=>{
    // console.log(to, from, next);
    // if(item.meta.isLogin){
    //   oidcJS.utils.isLogin(item.meta.permissions,next,to.fullPath);
    //   if(Object.keys(to.query).length){
    //     localStorage["returnUrl"] = to.fullPath;
    //   }else{
    //     localStorage.removeItem('returnUrl');
    //   }
    // }else{
    //   next()
    // }
    next()
  })
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js